import { Component } from '@angular/core';

@Component({
  selector: 'app-header-rulit',
  templateUrl: './header-rulit.component.html',
  styleUrls: ['./header-rulit.component.scss']
})
export class HeaderRulitComponent {

  constructor() { }

}
